// extracted by mini-css-extract-plugin
module.exports = {"nav":"HeaderNav_nav__2OH1r","nav__link":"HeaderNav_nav__link__2drd5","nav__linkMarked":"HeaderNav_nav__linkMarked__2YlYY","nav__linkActive":"HeaderNav_nav__linkActive__2exSR"};